import { DetailedHTMLProps, HTMLAttributes } from 'react';

const Column: React.FC<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = props => {
  return (
    <div {...props} style={{ display: 'flex', flexDirection: 'column', ...props.style }}>
      {props.children}
    </div>
  );
};

export default Column;
